import React, { useContext, useState } from 'react';
import { LoadingContext } from '@context/LoadingProvider';
import NewPassword from '../../../_molecules/NewPassword';
import { PasswordChangeContext } from '@context/PasswordChangeProvider';
import { authenticatePasswordReset } from '@general/api/memberAPI';
import { Redirect, useHistory } from 'react-router-dom';
import useStytchQueryString from '../../../../hooks/useStytchQueryString';
import Failure from './Failure';

const Authenticate = () => {
    const { setIsLoading } = useContext(LoadingContext);
    const stytchQueryString = useStytchQueryString();
    const { newPassword, setNewPasswordError, setConfirmPasswordError, setPasswordScore } = useContext(PasswordChangeContext);
    const [params] = useState(new URLSearchParams(window.location.search.slice(1)));
    const [stytchError] = useState(
        !params.has('stytch_token_type') || params.get('stytch_token_type') !== 'reset_password'
    );
    const [failure, setFailure] = useState(false);

    const resetPassword = () => {
        setIsLoading(true);
        setFailure(false);
        authenticatePasswordReset(params.get('token'), newPassword)
            .then(() => window.location.assign(`/login${stytchQueryString}`))
            .catch(e => {
                const error = e.response.data?.error_type;

                setPasswordScore(0);

                switch (error) {
                    case 'new_password_mismatch':
                        setConfirmPasswordError('Password does not match.');
                        break;
                    case 'breached_password':
                    case 'weak_password':
                        setNewPasswordError(
                            'The password you have chosen is not considered secure. Please choose a different password.'
                        );
                        break;
                    default:
                        setFailure(true);
                        break;
                }
            })
            .finally(() => setIsLoading(false));
    };

    if (stytchError) {
        return <Redirect to="/login" />;
    }

    if (failure) {
        return <Failure />;
    }

    return (
        <>
            <h2 className="display5 text-center bold mb-4">Reset your password</h2>
            <NewPassword onUpdate={resetPassword} />
        </>
    );
};

Authenticate.propTypes = {};

export default Authenticate;
